import { DateTime } from 'luxon';
import { ToDate } from './DateUtils';

export class GroupDateMapper {
  dayToDate: Record<number, string> = {};
  dateToDay: Record<string, number> = {};

  constructor(
    private readonly startDate: DateTime<true>,
    private readonly weeks: number = 13
  ) {
    const daysInWeek = 7;
    const totalDays = weeks * daysInWeek;
    for (let day = 0; day <= totalDays; day++) {
      const start = ToDate(startDate);

      const formattedDate = start.plus({ day: day }).toISODate() as string;
      this.dayToDate[day] = formattedDate;
      this.dateToDay[formattedDate] = day;
    }
  }

  public day = (date: string) => {
    return this.dateToDay[date] + 1;
  };

  public date = (day: number) => {
    return this.dayToDate[day - 1];
  };

  public lastWeek = (): { start: DateTime<true>; end: DateTime<true> } => {
    const now = DateTime.now();
    // Convert 'now' to the same timezone as the startDate
    const nowInZone = now.setZone(this.startDate.zoneName) as DateTime<true>;
    const weekStart = nowInZone.startOf('week').startOf('day'); // Gets the start of the week (Monday)
    const lastWeekStart = weekStart.minus({ weeks: 1 }); // Also a Monday
    const lastWeekEnd = weekStart.minus({ days: 1 }).endOf('day'); // Sunday
    return {
      start: lastWeekStart, // Monday
      end: lastWeekEnd, // Sunday
    };
  };

  public get lastWeekNumber() {
    return this.getLastWeekNumber() + 1;
  }

  public get lastWeekNumberIndexZero() {
    return this.getLastWeekNumber();
  }

  public get thisWeekNumber() {
    return this.lastWeekNumber + 1;
  }
  public get thisWeekNumberIndexZero() {
    return this.lastWeekNumberIndexZero + 1;
  }

  private getLastWeekNumber = () => {
    const { start } = this.lastWeek();

    return Math.floor(start.diff(this.startDate, 'weeks').weeks);
  };
}
